/// <reference path="../../opc-app/productline/productline.model.ts" />
/// <reference path="../../opc-app/productline/productline.model.ts" />
import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PartService } from '../../shared/services/part.service';
import { NotificationService } from '../../shared/services/notification.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Part } from '../../opc-app/part/part.model';
import { PartGroup } from '../../opc-app/partgroup/partgroup.model';
import { ColorCode } from '../../opc-app/part/colorcode.model';
import { Message } from 'primeng/api';
import { OPCConstant } from '../../opc-app/opc.const';
import { ExportService } from '../../shared/services/export.service';
import { PartGroupService } from '../../shared/services/partgroup.service';

@Component({
    selector: 'app-part',
    templateUrl: './part.component.html'
})
export class PartComponent implements OnInit {
  partGroupID: number;
  parts: Part[];
  newPart: Part;
  partGroup: PartGroup;
  colorCodes: any;
  added: boolean;
  notifications: Message[] = [];
  loading = false;
  pagedItems: any;
  startIndex: number;
  endIndex: number;
  private isBackButton = false;
  constructor(private _partService: PartService, private notifyService: NotificationService,
    private spinner: NgxSpinnerService, private _route: ActivatedRoute, private exportService: ExportService, private partGroupService: PartGroupService) {
    }
    setPageData(data: any) {
        this.pagedItems = this.parts.slice(data.startIndex, data.endIndex);
        this.startIndex = data.startIndex;
        this.endIndex = data.endIndex;
    }

  getParts() {
    this._partService.getAllPartsByPartGroupId(this.partGroupID).subscribe(res => {
            this.partGroup = res.item1;
            this.parts = res.item2;
          this.colorCodes = res.item3;          
            this.spinner.hide();
            this.loading = false;
        });
  }

  @HostListener('window:popstate', ['$event'])
  onpopstate(event: any) {
    // Handle restoring state like filters, pagination, etc.
    this.isBackButton = true;
    this.partGroupService.setSharedBackButtonValue(this.isBackButton);
  }

  ngOnInit(): void {    
        this.loading = true;
        this.spinner.show();
        this._route.params.subscribe(
            (params: Params) => {
                this.partGroupID = +params['id'];
                this.getParts();
            }
        );
    }
    onSubmit(event) {
        if (event) {
            this.added = false;
            this.newPart = new Part();
            const part = this.parts.find(p => p.partID === event.partID);
            if (part) {
                const index = this.parts.indexOf(part);
                this.parts[index] = event;
                this.notifications = this.notifyService.growlNotification('succ', OPCConstant.UPDATE_SUCCESS);
            } else {
                this.parts.unshift(event);
                this.notifications = this.notifyService.growlNotification('succ', OPCConstant.ADDED_SUCCESS);
            }
            this.pagedItems = this.parts.slice(this.startIndex, this.endIndex);
        }
    }
    onDelete(event, item) {
        if (event && item) {
            const index = this.parts.indexOf(item);
            this.parts.splice(+index, 1);
            this.notifications = this.notifyService.growlNotification('succ', OPCConstant.DELETE_SUCCESS);
        } else {
            this.added = false;
        }
    }
    onAddNew() {
        this.added = true;
        this.newPart = new Part();
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/part/part.component.ts